import { Timestamp } from '@principle-theorem/shared';

export enum BigQueryUploadJobStatus {
  Pending = 'pending',
  InProgress = 'inProgress',
  Completed = 'completed',
  Failed = 'failed',
}

export enum BigQueryUploadJobErrorOutcome {
  Retry = 'Retry',
  Fail = 'Fail',
}

export interface IBigQueryUploadJob {
  uid: string;
  dataset: string;
  table: string;
  files: string[];
  expiresAt: Timestamp;
  errorMessage?: string;
  errorOutcome?: BigQueryUploadJobErrorOutcome;
  status: BigQueryUploadJobStatus;
}

export interface IBigQueryUploadJobStats {
  total: IBigQueryUploadJobStat;
  success: IBigQueryUploadJobStat;
  failed: IBigQueryUploadJobStat;
  skipped: IBigQueryUploadJobStat;
}

export interface IBigQueryUploadJobStat {
  jobs: number;
  files: number;
}

export interface IBigQueryUploadJobPointer {
  dataset: string;
  table: string;
}

export type IBigQueryUploadJobStatGroup = Record<
  string,
  IBigQueryUploadJobStat
>;

export interface IBigQueryAvroFolderStats {
  evaluatedFolder: string;
  stats: IBigQueryUploadJobStats;
  byDataset: IBigQueryUploadJobStatGroup;
  byTable: IBigQueryUploadJobStatGroup;
  firstJobPointer?: IBigQueryUploadJobPointer;
  lastJobPointer?: IBigQueryUploadJobPointer;
}

export interface IBigQueryUploadStats extends IBigQueryAvroFolderStats {
  evaluatedAt: Timestamp;
  expiresAt: Timestamp;
  failedStats?: IBigQueryAvroFolderStats;
}
